module.exports = __webpack_public_path__ + "img/service07.a9d7c129.jpg";